export default __webpack_public_path__ + "static/media/LandingGIf1.0ff2ea75.gif";